import React, {FunctionComponent, useEffect, useState} from 'react';
import '@asseinfo/react-kanban/dist/styles.css'
import '../../../App.scss'
import {fetchPostBody} from "../../../utils/fetchUtils";
import {Auth} from "aws-amplify";
import {useNavigate} from "react-router-dom";
import Body1 from "../../../components/Typography/Body1";
import AsyncActionButton from "../../../components/AsyncActionButton/AsyncActionButton";
import {toast} from "react-toastify";
import TextField from "@material-ui/core/TextField";
import 'react-toastify/dist/ReactToastify.css';
import OurToastContainer from "../../../components/OurToastContainer/OurToastContainer";
import {normalizeUsername} from "../../../utils/usernameUtils";
import {setPageTitle} from "../../../utils/titleUtils";

const toastErrorId = "sign-up-error-toast-id"
const toastSuccessId = "sign-up-success-toast-id"
const toastContainerId = "sign-up-toast-container-id"

const ConfirmEmail: FunctionComponent<{}> = () => {
  const [emailInput, setEmailInput] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const notifyError = (message) => toast(message, {type: "error", pauseOnHover: true, toastId: toastErrorId, containerId: toastContainerId});
  const notifySuccess = (message) => toast(message, {type: "success", pauseOnHover: true, toastId: toastSuccessId, containerId: toastContainerId});


  const navigate = useNavigate();

  useEffect(() => {
    setPageTitle("Confirm Email");
  }, [])

  const handleInputChange = (event) => {
    setEmailInput(event.target.value);
  };

  function handleConfirm() {
    setIsSubmitting(true);
    return Auth.currentAuthenticatedUser({bypassCache: false})
               .then(currUser => {
                 return fetchPostBody('admin/email', {email: normalizeUsername(emailInput)}, currUser.getSignInUserSession()?.getIdToken().getJwtToken())
                   .then(() => {
                     setEmailInput("");
                     notifySuccess("Email set successfully!");
                   }).catch((err) => {
                     notifyError(err.message || "Something went wrong");
                   }).finally(() => setIsSubmitting(false))
               })
  }

  return (<div className=''>
      <h6 className="semi-bold">Confirm Email</h6>
      <div className="max-small-text-width">
        <Body1>Enter an email to confirm: <br></br></Body1>
        <Body1>Remember to ALWAYS use emails directly from the support ticket "FROM" field.</Body1>
        <div className="padding-block-self">
          <TextField label="Email"
                     name="email"
                     onChange={(event) => {
                       handleInputChange(event);
                     }}
                     value={emailInput}
                     fullWidth={true}
                     margin={"dense"}
                     type={"email"}
                     autoComplete={"email"}
                     variant={"outlined"}
          />
          <div className="padding-top"/>
          <AsyncActionButton action={handleConfirm}
                             disabled={!isSubmitting && emailInput.length !== 0}
                             color={"primary"}
                             text={"Confirm Email"}
                             variant={"contained"}/>
        </div>
      </div>
      <OurToastContainer containerId={toastContainerId}/>
    </div>
  );

}

export default ConfirmEmail;
